<template>
  <div class="course">
    <img class="flag" v-if="!!course.flag" :src="require(`@/assets/flags/${course.flag}`)" />
    <img class="flag" v-if="!!course.icon" :src="require(`@/assets/icons/${course.icon}`)" />
    <div class="info">
      <div v-html="course.title"></div>
      <template>
        <b v-if="course.pricing[entity].currency === 'nok'">{{$t('currency', {num: $options.filters.toCurrency(course.pricing[entity].year * vat)})}} / {{$t('license.term.privyear')}}</b>
        <b v-else>{{$options.filters.toCurrency(course.pricing[entity].year * vat, course.pricing[entity].currency)}} / {{$t('license.term.privyear')}}</b>
        <div style="font-size: 10px;">{{timeFrame}}</div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseCart',
  props: {
    course: Object,
    entity: String,
    period: String,
    vat: Number
  },
  data() {
    return {
    }
  },
  computed: {
    rebateActive() {
      return this.course.rebates.institution.validate(this.course);
    },
    institutionOrgPrice() {
      let price = this.course.pricing.institution;
      // if (this.course.rebates.semester.validate(this.period)) {
      //   price *= this.course.rebates.semester.intValue;
      // }
      return price;
    },
    institutionCoursePrice() {
      let price = this.course.pricing.institution;
      // if (this.course.rebates.semester.validate(this.period)) {
      //   price *= this.course.rebates.semester.intValue;
      // }
      if (this.course.rebates.institution.validate(this.course)) {
        price *= this.course.rebates.institution.intValue;
      }
      return price;
    },
    timeFrame() {
      let term = this.course.term;
      let now = this.$moment().format(this.$t('dateFormat'));
      let future = this.$moment().add(1, `${term}s`).subtract(1, 'days').format(this.$t('dateFormat'));
      return `${now} - ${future}`;
    }
  },
  methods: {
    onTerm(term) {
      this.$emit('term-change', term);
    }
  }
}
</script>

<style lang="scss">
.course .info {
  .title {
    font-weight: 500;
  }

  ul {
    font-size: 11px;
  }

  .right .ivu-radio-wrapper {
    font-size: 11px;
  }

}
</style>
<style scoped lang="scss">
div.course {
  display: block;
  margin: 20px 0;
}
div.info {
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
  margin-top: -3px;

  @media only screen and (max-width: 1200px) {
    margin-left: 15px;
  }

  max-width: 210px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
img.flag {
  max-width: 70px;
  height: auto;
}
div.right {
  float: right;
  margin-top: -6px;
}
</style>